import { useFeature } from "@optimizely/react-sdk";
import { Link, useParams } from "react-router-dom";

import { ReactComponent as Settings } from "../../img/settings.svg";
import { BrilliantDeviceTypes } from "../../interfaces/interfaces";

export interface IBrilliantDeviceCard {
  id: string;
  name: string;
  description: string;
  isReconfiguring?: boolean;
  icon: React.ReactNode;
  isOffline?: boolean;
  lastOnline?: string;
  isProView?: boolean;
  shouldShowSettingsRender?: boolean;
  deviceType?: BrilliantDeviceTypes;
}

const BrilliantDeviceCard: React.FC<IBrilliantDeviceCard> = ({
  id,
  name,
  description,
  isReconfiguring,
  icon,
  isOffline,
  lastOnline,
  isProView,
  shouldShowSettingsRender,
  deviceType,
}) => {
  const [brilliantDev] = useFeature("brilliant_dev");
  const params = useParams();
  const { organizationId, propertyId } = params;
  return (
    <div
      className={`brilliant-card-container ${
        isProView && "brilliant-card-container-pro-view"
      }`}
    >
      {icon}
      <div className="brilliant-card-description">
        <div className={`${isReconfiguring || isOffline ? "disabled" : ""}`}>
          <div className="unit-title hidden-name">{name}</div>
          <div className="brilliant-card-description-type unit-description-small flex-display uppercase">
            {description}
          </div>
        </div>
        {isReconfiguring && (
          <div
            className="brilliant-card-description-reconfiguring unit-device-id"
            data-testid={`device-card-reconfiguration-${id}`}
          >
            RECONFIGURING...
          </div>
        )}
        {isOffline && (
          <div className="brilliant-card-installation-error">OFFLINE</div>
        )}
        {lastOnline && brilliantDev && (
          <div className="brilliant-card-installation-error">
            Seen at {lastOnline}
          </div>
        )}
      </div>
      {shouldShowSettingsRender && (
        <Link
          to={`/${organizationId}/home/${propertyId}/device/${id}?device_type=${deviceType}`}
        >
          <Settings title="Settings" />
        </Link>
      )}
    </div>
  );
};

export default BrilliantDeviceCard;
